import { render, staticRenderFns } from "./ViewPreviousCoinflip.vue?vue&type=template&id=130c8e56&scoped=true"
import script from "./ViewPreviousCoinflip.vue?vue&type=script&lang=js"
export * from "./ViewPreviousCoinflip.vue?vue&type=script&lang=js"
import style0 from "./ViewPreviousCoinflip.vue?vue&type=style&index=0&id=130c8e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c8e56",
  null
  
)

export default component.exports